import Vue from 'vue'
import Vuex from 'vuex'
import router from '../src/router'

Vue.use(Vuex)
// no borrar Cristian Ubilla
//	prod antiguo: 'https://backcobranza.azurewebsites.net/',
//	prod nuevo: 'https://backcobranza.latamtradecapital.com/',
export default new Vuex.Store({
	state: {
		accessToken: null,
		accessTokenImg: null,
		logginIn: false,
		loginError: null,
		useraccess: null,
		idUser: null,
		auth2: null,
		authImg: null,
		apiurl: 'https://backcobranza.latamtradecapital.com/',
		apiurlImg: 'https://backimagenesnc.azurewebsites.net/',
		searchmenu: true,
		collapsemenu: false,
		filter: 'filter',
		accessRoles: [],
		accessMenu: [],
		accessPermisos: [],
		userPerfiles: [],
		initialViewC: 'dayGridMonth',
		dPaso: [],
		dPaso1: null,
		dPaso2: null,
		dPaso3: null,
		dPaso4: null,
		dPaso5: null,
		lineaNegocio: null,
		empresasList: null,
		colorBarra: '#1554f6',
		bgNavbarColor: '#1554f6',
		textNavbarColor: '#FFF',
		borderNavbarColor: 'rgba(255,255,255,.1)',
		logo: 'nuevo-capital.svg',
		isotipo: 'nuevo-capital-mini.svg',
		disabledLinea: false,
		refreshChecklistVerificacion: 0
	},
	mutations: {
		loginStart: (state) => {
			state.loggingIn = true
		},
		loginStop: (state, errorMessage) => {
			state.loggingIn = false
			state.loginError = errorMessage
		},
		updatefilter: (state, filtro) => {
			state.filter = filtro
		},
		updatesearchmenu: (state, estado) => {
			state.searchmenu = estado
		},
		updatecollapsemenu: (state, estado) => {
			state.collapsemenu = estado
		},
		updateuseraccess: (state, username) => {
			state.useraccess = username
		},
		updateIdUsuario: (state, idUsuario) => {
			state.idUser = idUsuario
		},
		updateDpaso0: (state, dPaso) => {
			state.dPaso = dPaso
		},
		updateDpaso: (state, dPaso1) => {
			state.dPaso1 = dPaso1
		},
		updateDpaso2: (state, dPaso2) => {
			state.dPaso2 = dPaso2
		},
		updateDpaso3: (state, dPaso3) => {
			state.dPaso3 = dPaso3
		},
		updateDpaso4: (state, dPaso4) => {
			state.dPaso4 = dPaso4
		},
		updateDpaso5: (state, dPaso5) => {
			state.dPaso5 = dPaso5
		},
		updateLineaNegocio: (state, lineaNegocio) => {
			state.lineaNegocio = lineaNegocio
		},
		updateEmpresasList: (state, empresasList) => {
			state.empresasList = empresasList
		},
		updateAccessToken: (state, accessToken) => {
			state.accessToken = accessToken
			state.auth2 = { headers: { 'Authorization': accessToken } }
		},
		updateAccessTokenImg: (state, accessToken) => {
			state.accessTokenImg = accessToken
			state.authImg = { headers: { 'Authorization': accessToken } }
		},
		updateAccessRoles: (state, accessRoles) => {
			state.accessRoles = accessRoles
		},
		updateAccessLineas: (state, accessLineas) => {
			state.accessLineas = accessLineas
		},
		updateAccessMenu: (state, accessMenu) => {
			state.accessMenu = accessMenu
		},
		updateAccessPermisos: (state, accessPermisos) => {
			state.accessPermisos = accessPermisos
		},
		updateinitialViewC: (state, initialViewC) => {
			state.initialViewC = initialViewC
		},
		logout: (state) => {
			state.accessToken = null
			state.accessTokenImg = null
			state.auth2 = null
			state.userPerfiles = []
			state.lineaNegocio = null
			localStorage.removeItem('arrayFichas')
		},
		updatePerfiles: (state, userPerfiles) => {
			state.userPerfiles = userPerfiles
		},
		setColorBarra: (state, colorBarra) => {
			state.colorBarra = colorBarra
		},
		setBgNavbarColor: (state, bgNavbarColor) => {
			state.bgNavbarColor = bgNavbarColor
		},
		setTextNavbarColor: (state, textNavbarColor) => {
			state.textNavbarColor = textNavbarColor
		},
		setBorderNavbarColor: (state, borderNavbarColor) => {
			state.borderNavbarColor = borderNavbarColor
		},
		setLogo: (state, logo) => {
			state.logo = logo
		},
		setIsotipo: (state, isotipo) => {
			state.isotipo = isotipo
		},
		setDisabledLinea: (state, disabledLinea) => {
			state.disabledLinea = disabledLinea
		},
		setRefreshChecklistVerificacion: (state, refreshChecklistVerificacion) => {
			state.refreshChecklistVerificacion = refreshChecklistVerificacion
		}
	},
	actions: {
		doLogin ({ commit }, token) {
			commit('loginStart')
			if (token === '0') {
			  localStorage.setItem('loginError', 0)
			  commit('loginStop', 'error token')
			  commit('updateAccessToken', null)
			  return false
			} else {
			  localStorage.setItem('accessToken', token)
			  commit('updateAccessToken', token)
			}
		},
		doLoginImg ({ commit }, token) {
			if (token === '0' || token === 0) {
			  localStorage.setItem('accessTokenImg', 0)
			  commit('updateAccessToken', null)
			  return false
			} else {
			  localStorage.setItem('accessTokenImg', token)
			  commit('updateAccessTokenImg', token)
			}
		},
		doUsername ({ commit }, username) {
			  localStorage.setItem('useraccess', username)
			  commit('updateuseraccess', username)

			// Al momento de loguear, preguntamos si usuario tiene 1 solo rol asignado
			let roles = JSON.parse(localStorage.getItem('accessRoles'))
			let rol = roles[0]['rol']
			let countRoles = JSON.parse(localStorage.getItem('accessRoles')).length
			if (countRoles === 1) {
				if (rol === 'Verificador' || rol === 'Verificador Agente') {
					router.push('/Verificacion')
				} else if (rol === 'Viewer Castigos' || rol === 'Editar Castigos' || rol === 'Fiscalia Castigos') {
					router.push('/Castigados/Listado')
				} else if (rol === 'Carga Castigos') {
					router.push('/Castigados/Carga')
				} else if (rol === 'facturacion') {
					router.push('/FacturadorEfacobb')
				} else {
					router.push('/Resumen')
				}
			} else {
				let soloRolesTipoCastigos = true
				for (let x = 0; x < countRoles; x++) {
					let r = roles[x]['rol'].toLowerCase()
					if (!r.includes('castigos')) {
						soloRolesTipoCastigos = false
					}
				}
				if (soloRolesTipoCastigos) {
					router.push('/Castigados/Listado')
				} else {
					router.push('/Resumen')
				}
			}
		},
		fetchAccessToken ({ commit }) {
			commit('updateDpaso', localStorage.getItem('dPaso1'))
			commit('updateDpaso0', localStorage.getItem('dPaso'))
			commit('updateDpaso2', localStorage.getItem('dPaso2'))
			commit('updateDpaso3', localStorage.getItem('dPaso3'))
			commit('updateDpaso4', localStorage.getItem('dPaso4'))
			commit('updateDpaso5', localStorage.getItem('dPaso5'))
			commit('updateLineaNegocio', localStorage.getItem('lineaNegocio') ? JSON.parse(localStorage.getItem('lineaNegocio')) : null)
			commit('updateIdUsuario', localStorage.getItem('IdUser'))
			commit('updateAccessToken', localStorage.getItem('accessToken'))
			commit('updateAccessTokenImg', localStorage.getItem('accessTokenImg'))
			commit('updateuseraccess', localStorage.getItem('useraccess'))
			commit('updatePerfiles', localStorage.getItem('userPerfiles') ? JSON.parse(localStorage.getItem('userPerfiles')) : null)
			commit('setColorBarra', localStorage.getItem('colorBarra'))
			commit('setBgNavbarColor', localStorage.getItem('bgNavbarColor'))
			commit('setTextNavbarColor', localStorage.getItem('textNavbarColor'))
			commit('setBorderNavbarColor', localStorage.getItem('borderNavbarColor'))
			commit('setLogo', localStorage.getItem('logo'))
			commit('setIsotipo', localStorage.getItem('isotipo'))
			commit('setDisabledLinea', false)
			commit('setRefreshChecklistVerificacion', 0)

			if (localStorage.getItem('empresasList') === undefined || localStorage.getItem('empresasList') === 'undefined') {
				commit('updateEmpresasList', null)
			} else {
				commit('updateEmpresasList', localStorage.getItem('empresasList') ? JSON.parse(localStorage.getItem('empresasList')) : null)
			}
		},
		fetchAccessMenu ({ commit }) {
			commit('updateAccessRoles', localStorage.getItem('accessRoles') ? JSON.parse(localStorage.getItem('accessRoles')) : null)
			commit('updateAccessLineas', localStorage.getItem('accessLineas') ? JSON.parse(localStorage.getItem('accessLineas')) : null)
			commit('updateAccessMenu', localStorage.getItem('accessMenu') ? JSON.parse(localStorage.getItem('accessMenu')) : null)
			commit('updateAccessPermisos', localStorage.getItem('accessPermisos') ? JSON.parse(localStorage.getItem('accessPermisos')) : null)
		},
		logout ({ commit }) {
			localStorage.removeItem('accessToken')
			localStorage.removeItem('accessTokenImg')
			localStorage.removeItem('IdUser')
			localStorage.removeItem('lineaNegocio')
			localStorage.removeItem('empresasList')
			localStorage.removeItem('colorBarra')
			localStorage.removeItem('bgNavbarColor')
			localStorage.removeItem('textNavbarColor')
			localStorage.removeItem('borderNavbarColor')
			localStorage.removeItem('logo')
			localStorage.removeItem('isotipo')
			localStorage.removeItem('accessRoles')
			localStorage.removeItem('userPerfiles')
			localStorage.removeItem('accessMenu')
			localStorage.removeItem('accessPermisos')
			localStorage.removeItem('accessLineas')
			localStorage.removeItem('dPaso1')
			localStorage.removeItem('useraccess')
			commit('logout')
			router.push('/Login')
		},
		logoutError ({ commit }) {
			localStorage.removeItem('accessToken')
			localStorage.removeItem('accessTokenImg')
			localStorage.removeItem('IdUser')
			localStorage.removeItem('lineaNegocio')
			localStorage.removeItem('empresasList')
			localStorage.removeItem('colorBarra')
			localStorage.removeItem('bgNavbarColor')
			localStorage.removeItem('textNavbarColor')
			localStorage.removeItem('borderNavbarColor')
			localStorage.removeItem('logo')
			localStorage.removeItem('isotipo')
			localStorage.removeItem('accessRoles')
			localStorage.removeItem('userPerfiles')
			localStorage.removeItem('accessMenu')
			localStorage.removeItem('accessPermisos')
			localStorage.removeItem('accessLineas')
			localStorage.removeItem('dPaso1')
			localStorage.removeItem('useraccess')
			commit('logout')
		},
		doSearchmenu ({ commit }, estado) {
			commit('updatesearchmenu', estado)
		},
		doCollapsemenu ({ commit }, estado) {
			commit('updatecollapsemenu', estado)
		},
		doFilter ({ commit }, filtro) {
			commit('updatefilter', filtro)
		},
		doMenu ({ commit }, menu) {
			localStorage.setItem('accessMenu', JSON.stringify(menu))
			commit('updateAccessMenu', menu)
		},
		doRoles ({ commit }, roles) {
			localStorage.setItem('accessRoles', JSON.stringify(roles))
			commit('updateAccessRoles', roles)
		},
		doLineas ({ commit }, lineas) {
			localStorage.setItem('accessLineas', JSON.stringify(lineas))
			commit('updateAccessLineas', lineas)
		},
		doPermisos ({ commit }, permisos) {
			localStorage.setItem('accessPermisos', JSON.stringify(permisos))
			commit('updateAccessPermisos', permisos)
		},
		doIdiUser ({ commit }, idUsuario) {
			localStorage.setItem('IdUser', idUsuario)
			commit('updateIdUsuario', idUsuario)
		},
		doinitialViewC ({ commit }, initialViewC) {
			commit('updateinitialViewC', initialViewC)
		},
		doDpaso0 ({ commit }, dPaso) {
			localStorage.setItem('dPaso', JSON.stringify(dPaso))
			commit('updateDpaso0', dPaso)
		},
		doDpaso ({ commit }, dPaso1) {
			localStorage.setItem('dPaso1', dPaso1)
			commit('updateDpaso', dPaso1)
		},
		doDpaso2 ({ commit }, dPaso2) {
			localStorage.setItem('dPaso2', dPaso2)
			commit('updateDpaso2', dPaso2)
		},
		doDpaso3 ({ commit }, dPaso3) {
			localStorage.setItem('dPaso3', dPaso3)
			commit('updateDpaso3', dPaso3)
		},
		doDpaso4 ({ commit }, dPaso4) {
			localStorage.setItem('dPaso4', dPaso4)
			commit('updateDpaso4', dPaso4)
		},
		doDpaso5 ({ commit }, dPaso5) {
			localStorage.setItem('dPaso5', dPaso5)
			commit('updateDpaso5', dPaso5)
		},
		doLineaNegocio ({ commit }, lineaNegocio) {
			localStorage.setItem('lineaNegocio', JSON.stringify(lineaNegocio))
			commit('updateLineaNegocio', lineaNegocio)
		},
		doEmpresas ({ commit }, empresasList) {
			localStorage.setItem('empresasList', JSON.stringify(empresasList))
			commit('updateEmpresasList', empresasList)
		},
		doPerfiles ({ commit }, userPerfiles) {
			localStorage.setItem('userPerfiles', JSON.stringify(userPerfiles))
			commit('updatePerfiles', userPerfiles)
		},
		doFichaGestion ({ commit }, params) {
			var arrayFichas = []
			if (localStorage.getItem('arrayFichas')) {
				arrayFichas = JSON.parse(localStorage.getItem('arrayFichas'))
			}
			arrayFichas.push(params)
			localStorage.setItem('arrayFichas', JSON.stringify(arrayFichas))
		},
		doGestionMora ({ commit }, params) {
			localStorage.setItem('dataGestionMora', JSON.stringify(params))
		},
		setColorBarra ({ commit }, colorBarra) {
			localStorage.setItem('colorBarra', colorBarra)
			commit('setColorBarra', colorBarra)
		},
		setBgNavbarColor: ({ commit }, bgNavbarColor) => {
			localStorage.setItem('bgNavbarColor', bgNavbarColor)
			commit('setBgNavbarColor', bgNavbarColor)
		},
		setTextNavbarColor: ({ commit }, textNavbarColor) => {
			localStorage.setItem('textNavbarColor', textNavbarColor)
			commit('setTextNavbarColor', textNavbarColor)
		},
		setBorderNavbarColor: ({ commit }, borderNavbarColor) => {
			localStorage.setItem('borderNavbarColor', borderNavbarColor)
			commit('setBorderNavbarColor', borderNavbarColor)
		},
		setLogo: ({ commit }, logo) => {
			localStorage.setItem('logo', logo)
			commit('setLogo', logo)
		},
		setIsotipo: ({ commit }, isotipo) => {
			localStorage.setItem('isotipo', isotipo)
			commit('setIsotipo', isotipo)
		},
		setDisabledLinea: ({ commit }, disabledLinea) => {
			localStorage.setItem('disabledLinea', disabledLinea)
			commit('setDisabledLinea', disabledLinea)
		},
		setRefreshChecklistVerificacion: ({ commit }, refreshChecklistVerificacion) => {
			localStorage.setItem('refreshChecklistVerificacion', refreshChecklistVerificacion)
			commit('setRefreshChecklistVerificacion', refreshChecklistVerificacion)
		}
	},
	getters: {}
})



// WEBPACK FOOTER //
// ./src/store.js